import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const fileApi = createApi({
  reducerPath: 'fileApi',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['files'],
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: (file) => ({
        url: `upload/files`,
        method: 'POST',
        body: file,
      }),
    }),
    getFiles: builder.query({
      query: ({ category, folder }) => ({
        url: `category-dir/${category}/files/${folder}?limit=${1000}`,
        method: 'GET',
      }),
    }),
    updateFileStatusApproved: builder.mutation({
      query: ({ id, data }) => ({
        url: `category-dir/${id}/approve`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['files'],
    }),
    updateFileStatusRejected: builder.mutation({
      query: ({ id }) => ({
        url: `category-dir/${id}/reject`,
        method: 'PUT',
      }),
      invalidatesTags: ['files'],
    }),
     getFileByCategoryId: builder.query({
      query: ({ id, search }) => ({
        url: `categories/${id}/files?page=${1}&limit=${600}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['files'],
    }),
    getFileDashboard: builder.query({
      query: ({ time_range, search, folder_limit ,recent_status_filter }) => {
        let url = `admin/files?time_range=${time_range}&folder_limit=${folder_limit}`;
        if (search) {
          url += `&search=${search}`;
        }
        if (recent_status_filter) {
          url += `&recent_status_filter=${recent_status_filter}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
    }),
    getProjectFiles: builder.query({
      query: ({ project_name }) => {
        let url = `view-project-files`;
        if (project_name) {
          url += `?project_name=${project_name}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
    }),
    getSharedPostFiles: builder.query({
      query: (token) => ({
        url: `/category-dir/folder/shared-posts/${token}`,
        method: 'GET',
      }),
    }),
    getUserFiles: builder.query({
       query: () => ({
        url: `files?limit=${2000}`,
        method: 'GET',
      }),
    }),

    
  }),
});

export const {
  useUploadImageMutation,
  useLazyGetFilesQuery,
  useUpdateFileStatusApprovedMutation,
  useUpdateFileStatusRejectedMutation,
  useGetFileDashboardQuery,
  useGetFileByCategoryIdQuery,
  useGetSharedPostFilesQuery,
  useGetProjectFilesQuery,
  useGetUserFilesQuery,
} = fileApi;
